import axios from "axios";
import { message } from "antd";
import { API_HOST, SSO_URL } from "../constant";

let isRefreshing = false;
let refreshQueue = [];

function processQueue(success) {
  refreshQueue.forEach((cb) => cb(success));
  refreshQueue = [];
}

const apiInstance = axios.create({ baseURL: API_HOST, withCredentials: true });

apiInstance.interceptors.response.use(async (response) => {
  const { resultCode, resultMessage } = response.data;
  if (resultCode === -1 && resultMessage === "로그인이 필요합니다.") {
    if (isRefreshing) {
      return new Promise((resolve) => {
        refreshQueue.push((success) => resolve(success ? apiInstance(response.config) : response));
      });
    }
    isRefreshing = true;
    try {
      await axios.post(`${SSO_URL}/auth/token/refresh`, {}, { withCredentials: true });
      processQueue(true);
      return apiInstance(response.config);
    } catch {
      processQueue(false);
      return response;
    } finally {
      isRefreshing = false;
    }
  }
  return response;
});

/**
 *
 * @param {object} param
 * @param {'get' | 'post' | 'put' | 'patch' |'delete' =} param.method
 * @param {string} param.url
 * @param {object=} param.params
 * @param {object=} param.data
 * @param {object=} param.totalCount
 */
export function callApi({ method = "get", url, params, data }) {
  try {
    return apiInstance({
      url,
      method,
      params,
      data,
    }).then((response) => {
      const { resultCode, resultMessage, totalCount } = response.data;
      if (resultCode < 0) {
        message.error(resultMessage);
      }
      return {
        isSuccess: resultCode === ResultCode.Success,
        data: response.data.data,
        resultCode,
        resultMessage,
        totalCount,
      };
    });
  } catch (err) {
    console.log(err);
    return {
      isSuccess: false,
      data: null,
      resultCode: "ERROR",
      resultMessage: err,
      totalCount: 0,
    };
  }
}

export const ResultCode = {
  Success: 0,
  Fail: 999,
};

export function callSsoApi({ method = "post", url, data }) {
  return axios({
    url,
    method,
    baseURL: SSO_URL,
    data,
    withCredentials: true,
  }).then((response) => {
    return { isSuccess: true, data: response.data.data };
  }).catch((err) => {
    const resultMessage = err.response?.data?.resultMessage || "오류가 발생했습니다.";
    return { isSuccess: false, data: null, resultMessage };
  });
}
